"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSearch = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const InputBase_1 = tslib_1.__importDefault(require("@mui/material/InputBase"));
const system_1 = require("@mui/system");
const providers_1 = require("@mne-core/providers");
const IconComponent_1 = tslib_1.__importDefault(require("./IconComponent"));
const useBreakpoints_1 = require("./useBreakpoints");
const Search = (0, system_1.styled)("div")(({ theme }) => ({
    name: "Search",
    slot: "Root",
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: (0, system_1.alpha)(theme.palette.common.white, 0.15),
    "&:hover": {
        backgroundColor: (0, system_1.alpha)(theme.palette.common.white, 0.25),
    },
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(3),
        width: "auto",
    },
}));
const SearchIconWrapper = (0, system_1.styled)("div")(({ theme }) => ({
    name: "SearchIconWrapper",
    slot: "Root",
    color: theme.palette.common.white,
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
const StyledInputBase = (0, system_1.styled)(InputBase_1.default)(({ theme }) => ({
    name: "Input",
    slot: "Root",
    color: theme.palette.common.white,
    "& .MuiInputBase-input": {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: "1em",
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            paddingLeft: `calc(1em + ${theme.spacing(4)})`,
            width: "20ch",
        },
    },
}));
const handleSearch = (event) => {
    // Using `currentTarget` instead of `target`. Since TS lies and says `target.value` is not defined
    const inputValue = event.currentTarget.value;
    // We only care about if the user press enter.
    if (!(event.key === "Enter"))
        return;
    event.preventDefault();
    const AGGREGATED_EVENT_REGEX = /^(AGGR|NIDS)/;
    // If this is an aggregated event, redirect to event page.
    if (inputValue.match(AGGREGATED_EVENT_REGEX)) {
        window.location.href = (0, providers_1.toSpaUrl)({
            pathname: `/event/redirect/view/${inputValue}`,
            search: "",
        });
    }
    else {
        // Everything not an aggregated event, redirect to case.
        window.location.href = (0, providers_1.toSpaUrl)({
            pathname: `case/redirect/menuSearch/`,
            search: (0, providers_1.encodeUrlCriteria)({
                inputValue,
            }),
        });
    }
};
exports.handleSearch = handleSearch;
const ArgusMenuSearch = ({ label, logger }) => {
    const { isMobile } = (0, useBreakpoints_1.useBreakpoints)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Search, null,
            !isMobile && (react_1.default.createElement(SearchIconWrapper, null,
                react_1.default.createElement(IconComponent_1.default, { iconId: "search", logger: logger }))),
            react_1.default.createElement(StyledInputBase, { onKeyDown: exports.handleSearch, placeholder: label, inputProps: { "aria-label": "search" } }))));
};
exports.default = ArgusMenuSearch;
